import { useMutation } from '@tanstack/react-query'

import { BoundingBoxToolData, ToolTypes } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

type PredictionRequest = {
  name: string
  mediaId: string
  tool: {
    type: ToolTypes
    metadata: object
    data: BoundingBoxToolData
  }
}

type Request = {
  mediaIds: string[]
  defaultMediaId?: string
  programName: string
  associatedEngagementId?: string
  instructions: string
  webhookUrl?: string
  externalId?: string
  metadata: object
  systemId: string
  softwareVersion: string
  requestedResponse?: string
  predictions: PredictionRequest[]
  location: {
    latitude: number
    longitude: number
  }
}

type Response = {
  id: string
}

export function useCreate() {
  return useMutation({
    mutationFn: async (payload: Request) => {
      const { data } = await apiClient.post<Response>(`/v2/engagements`, payload)
      return data
    },
  })
}
